import React from 'react'
import './ClickItem.css'

export default function ClickItem({ children, className, type = 'button', ...rest }) {
  const cls = ['clickItem', className].filter(Boolean).join(' ')
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  )
}
